module.exports = __webpack_public_path__ + "img/202311011058045206ce.034b32a0.jpg";